module.exports = __webpack_public_path__ + "img/1737565940310.77a657a5.jpg";